<script setup>
import { computed, defineProps } from "vue";
import { useStore } from "vuex";
import MainSection from "./MainSection.vue";

const props = defineProps({
  bg: {
    type: String,
    required: true,
    validator: (value) => ["login", "error", "basic"].includes(value),
  },
});

const store = useStore();

const darkMode = computed(() => store.state.darkMode);

const componentClass = computed(() => {
  const bgs = {
    login: "white-smoke",
    // login: 'bg-[url("https://kreditstorage.b-cdn.net/logo/ko_login_bg.jpg")] bg-cover bg-center',
    error: "bg-gradient-to-tr from-pink-400 via-red-500 to-yellow-500",
  };

  const bgKey = darkMode.value ? `${props.bg}Dark` : props.bg;

  return bgs[bgKey] ?? "";
});
</script>

<template>
  <main-section :class="componentClass">
    <slot
      card-class="w-11/12 md:w-7/12 lg:w-6/12 xl:w-4/12 shadow-2xl"
      card-rounded="rounded-lg"
    />
  </main-section>
</template>
